import { cn } from "@super-resume-new/ui/lib/utils";
import { Link } from "@tanstack/react-router";
import { Wand2, Zap } from "lucide-react";

type Props = {
  current: "tailor" | "ats-booster";
};

const TOOLS = [
  {
    key: "tailor",
    to: "/resume-tailor",
    label: "Resume tailor",
    icon: Wand2,
    active: "border-primary text-primary",
  },
  {
    key: "ats-booster",
    to: "/ats-booster",
    label: "ATS booster",
    icon: Zap,
    active: "border-emerald-500 text-emerald-500",
  },
] as const;

export function ToolSwitcher({ current }: Props) {
  return (
    <div className="mb-6 flex justify-center border-b border-border">
      {TOOLS.map(({ key, to, label, icon: Icon, active }) => {
        const isActive = current === key;
        return (
          <Link
            key={key}
            to={to}
            className={cn("flex items-center gap-2 border-b-2 px-5 py-3 text-m font-medium transition", {
              [active]: isActive,
              "border-transparent text-muted-foreground hover:text-foreground": !isActive,
            })}
          >
            <Icon className="size-3.5" aria-hidden="true" />
            <span>{label}</span>
          </Link>
        );
      })}
    </div>
  );
}
